/*
 * For creating actions that are purely for the purpose of being logged by a middleware
 */

const LOG_EVENT = 'common/logging/LOG_EVENT'

const logEvent = (category, action, label, value) => ({
  type: LOG_EVENT,
  category,
  action,
  label,
  value,
})

export {
  LOG_EVENT,
  logEvent,
}
